<template>
    <div>

    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */
    export default {
        name: 'tms-type-custom-list',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },

        components: {},

        mounted() {

        },

        methods: {}
    }

</script>
